import { Button, Divider, Modal, Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { TasksTypesNames } from 'src/pages/goldenMay2026/constants'
import { useTasksTypesList } from 'src/pages/goldenMay2026/tasks/hooks'
import { disableTaskTypeEvent } from 'src/pages/goldenMay2026/tasks/model'
import { TaskType } from 'src/pages/goldenMay2026/tasks/types'

type Props = {
  isVisible: boolean
  onClose: () => void
}

export const ChangeTaskModal = ({ isVisible, onClose }: Props) => {
  const { tasksTypes, loading } = useTasksTypesList()

  const columns: ColumnsType<TaskType> = [
    {
      title: 'Task type',
      dataIndex: 'taskType',
      render: (item: string) =>
        TasksTypesNames[item as keyof typeof TasksTypesNames],
    },
    {
      title: '',
      align: 'center',
      render: (item: TaskType) => {
        if (item.disabledAt) {
          return <></>
        }
        return (
          <Button
            color="volcano"
            variant="solid"
            onClick={() => {
              if (window.confirm('Are you sure?')) {
                disableTaskTypeEvent({ id: item.taskType })
                onClose()
              }
            }}
          >
            Disable
          </Button>
        )
      },
    },
  ]

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Types of tasks</div>}
      centered
      wrapClassName="ant_modal"
      width={700}
      maskClosable={false}
      open={isVisible}
      destroyOnHidden
      onCancel={onClose}
      footer={null}
    >
      <Divider />
      <Table
        dataSource={tasksTypes}
        bordered={true}
        className="overflow-auto"
        loading={loading}
        rowKey={(record) => record.taskType}
        columns={columns}
        pagination={false}
      />
    </Modal>
  )
}
